"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.Youtube = /*#__PURE__*/function () {
  function Youtube(youtube) {
    (0, _classCallCheck2["default"])(this, Youtube);
    this.generateView(youtube);
  }
  return (0, _createClass2["default"])(Youtube, [{
    key: "init",
    value: function init(youtube) {
      this.youtubeHash = youtube;
      this.generateView();
    }
  }, {
    key: "generateView",
    value: function generateView(youtubeHash) {
      var movieContainer = Entry.createElement('div');
      movieContainer.addClass('entryContainerMovieWorkspace');
      movieContainer.addClass('entryRemove');
      this.movieContainer = movieContainer;
      var url = 'https://www.youtube.com/embed/';
      var iframe = Entry.createElement('iframe');
      iframe.setAttribute('id', 'youtubeIframe');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', 0);
      iframe.setAttribute('src', url + youtubeHash);
      this.movieFrame = iframe;
      this.movieContainer.appendChild(iframe);
    }
  }, {
    key: "getView",
    value: function getView() {
      return this.movieContainer;
    }
  }, {
    key: "resize",
    value: function resize() {
      var container = document.getElementsByClassName('propertyContent')[0];
      var iframe = document.getElementById('youtubeIframe');
      var w = container.offsetWidth;
      iframe.width = "".concat(w, "px");
      iframe.height = "".concat(w * 9 / 16, "px");
    }
  }]);
}();